import { fetch, get } from '@mitchell/typescript.service.fetch';
import { EnvironmentService, HttpCacheType } from "../../common";
export class RepairResourceLookupService {
    constructor(fetchWrapper = fetch) {
        this.fetchWrapper = fetchWrapper;
        this.apiUrl = EnvironmentService.getEnvironment().connectServicesUrl;
    }
    static getInstance() {
        if (!RepairResourceLookupService.instance) {
            RepairResourceLookupService.instance = new RepairResourceLookupService();
        }
        return RepairResourceLookupService.instance;
    }
    /**
     * this method is used to fetch list of repair resources
     * @param repairResourcePayload represents the payload required to fetch list of repair resources
     * @param isResourceRepairOrchestratorUrl {boolean} [optional] represent the boolean according to which url will be selected to fetch
     * @returns SAGASERVICEONLY_IResourceLookupResponse[]
     */
    getRepairResources(repairResourcePayload, isResourceRepairOrchestratorUrl = false) {
        const pragma = {
            Pragma: HttpCacheType.NO_CACHE
        };
        const apiUri = this.getRepairResourceURL(repairResourcePayload, isResourceRepairOrchestratorUrl);
        const request = new Request(apiUri, {
            cache: HttpCacheType.NO_CACHE
        });
        return get(request, pragma, this.fetchWrapper);
    }
    getRepairResourceURL(repairResourcePayload, isResourceRepairOrchestratorUrl) {
        const { companyCode, countryCode, radius, searchBy, userType, lat, long, postalCode, sortField } = repairResourcePayload;
        const appendUrl = postalCode ? `postalcode=${postalCode.toUpperCase()}` : `lat=${lat}&long=${long}`;
        const queryString = '?' +
            Object.keys({ userType, searchBy, countryCode, radius, sortField })
                .map(key => {
                return `${key.toLowerCase()}=${encodeURIComponent(repairResourcePayload[key])}`;
            })
                .join('&');
        if (isResourceRepairOrchestratorUrl) {
            return `${EnvironmentService.getEnvironment().apdApiGatewayRoot}consumer-repair-app-api/v1/companies/${companyCode}/getresourcelookupdetails/${queryString}&${appendUrl}`;
        }
        else {
            return `${this.apiUrl}ResourceLookupRESTWS/v1/users/coCode/${companyCode}${queryString}&${appendUrl}`;
        }
    }
}
//# sourceMappingURL=RepairResourceLookupService.js.map